// 曝瓜网 · 首页结构类静态数据

export const siteNav = [
  { key: "latest", label: "最新实锤", icon: "ri-flashlight-line" },
  { key: "live", label: "直播电商", icon: "ri-live-line" },
  { key: "mcn", label: "网红MCN", icon: "ri-team-line" },
  { key: "ent", label: "影视娱乐", icon: "ri-clapperboard-line" },
  { key: "brand", label: "品牌消费", icon: "ri-store-2-line" },
  { key: "game", label: "游戏电竞", icon: "ri-gamepad-line" },
  { key: "work", label: "饭圈职场", icon: "ri-briefcase-4-line" },
];

export const tickerItems = [
  { tag: "石锤", text: "某头部直播基地被曝「假一赔十」货不对板，发货批次与核验底单全部对不上。" },
  { tag: "跟进", text: "曜星文化就员工匿名帖放出第三批聊天记录，指向考勤与绩效核算。" },
  { tag: "新流出", text: "一份标注「内部勿传」的选品报价表流出，佣金区间疑似多档差异巨大。" },
  { tag: "录音", text: "52 秒录音曝光引发热议，对话中疑似涉及压价与返点勾兑。" },
  { tag: "反方", text: "涉事方晚间声明称网传截图系拼接，称将联合平台走司法取证流程。" },
  { tag: "追更", text: "汐芽美学直播间带货成分表争议发酵，当事博主放出发货批次质检单自证。" },
  { tag: "图证", text: "朴造餐饮后厨监控截图被陆续补充，评论区已出现现场比对帖。" },
];

export const heatTopics = [
  { name: "假一赔十翻车", wave: 96, dir: "up", note: "直播电商" },
  { name: "MCN 抽成内幕", wave: 91, dir: "up", note: "网红MCN" },
  { name: "成分表争议", wave: 84, dir: "new", note: "品牌消费" },
  { name: "选品报价单", wave: 79, dir: "up", note: "直播电商" },
  { name: "考勤绩效罗生门", wave: 72, dir: "down", note: "饭圈职场" },
  { name: "返点录音", wave: 66, dir: "up", note: "网红MCN" },
  { name: "后厨监控比对", wave: 58, dir: "new", note: "品牌消费" },
];

export const heroLead = {
  channel: "直播电商",
  time: "今日 18:20",
  verified: true,
  title: "「假一赔十」承诺货不对板：发货批次、核验底单与订单时间线全面对不上",
  summary:
    "曝瓜网核查了三个月内的 47 张发货面单与 12 份抽检底单，发现同一 SKU 的批次号存在多段断档，且与直播间的承诺核验流程不一致。当事人已放出部分原始文件，目前石锤指向「贴牌换芯」而非单纯漏发。",
  evidence: ["发货底单 12 份", "面单 47 张", "批次时间线", "质检对比"],
  readCount: "186万",
  commentCount: "2.4万",
};

export const leadCards = [
  {
    channel: "录音曝光",
    time: "2 小时前",
    title: "52 秒通话录音流出：压价话术与返点数额被逐句拆解",
    image:
      "https://readdy.ai/api/search-image?query=dark%20editorial%20photography%20of%20a%20smartphone%20lying%20on%20a%20warm%20wooden%20desk%20playing%20a%20voice%20recording%20waveform%20with%20leaked%20chat%20paperwork%20beside%20it%2C%20moody%20cinematic%20lighting%2C%20deep%20shadow%2C%20newspaper%20evidence%20archive%20vibe%2C%20warm%20tones%20and%20crimson%20accents&width=800&height=500&seq=lead-audio-01&orientation=landscape",
    linkLabel: "逐句转写对照",
  },
  {
    channel: "截图流出",
    time: "5 小时前",
    title: "选品报价单被晒出：同款佣金四档报价差异引发集中质疑",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20a%20glowing%20screen%20showing%20a%20spreadsheet%20with%20price%20quotes%20and%20commission%20tiers%20on%20a%20cluttered%20work%20desk%2C%20handwritten%20notes%20and%20coffee%20cup%2C%20editorial%20documentary%20style%2C%20soft%20warm%20desk%20lamp%20light%2C%20evidence%20investigation%20atmosphere&width=800&height=500&seq=lead-sheet-01&orientation=landscape",
    linkLabel: "报价单比对",
  },
  {
    channel: "聊天记录",
    time: "昨天 22:40",
    title: "绩效核算之争再反转：第三批群聊记录指向考勤口径差异",
    image:
      "https://readdy.ai/api/search-image?query=overhead%20shot%20of%20a%20messaging%20app%20conversation%20on%20a%20laptop%20and%20phone%2C%20chat%20bubbles%20with%20dates%20and%20timestamps%2C%20documents%20fanned%20out%20nearby%2C%20documentary%20evidence%20style%2C%20warm%20desk%20lighting%2C%20investigative%20journalism%20mood&width=800&height=500&seq=lead-chat-01&orientation=landscape",
    linkLabel: "群聊时间线",
  },
];

export const quickLinks = [
  { label: "证据链专题", icon: "ri-link" },
  { label: "进群追更", icon: "ri-group-line" },
  { label: "投稿入口", icon: "ri-upload-cloud-2-line" },
  { label: "辟谣台", icon: "ri-shield-check-line" },
];